// src/pages/Home/Home.jsx
import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axios";
import Slider from "../../components/Home/Slider";
import FAQ from "../../components/Home/FAQ";
import AboutSection from "../../components/Home/AboutSection";
import OurProducts from "../../components/Home/OurProducts";
import OurService from "../../components/Home/OurService";
import WhyChooseUs from "../../components/Home/WhyChooseUs";
import Partners from "../../components/Home/Partners";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";
import Service from "../../components/Home/Service";

const Home = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get("/services/all");
        setServices(res.data);
      } catch (error) {
        console.error("Error fetching services:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <div>
      <Slider />
      <Service />
      <AboutSection />
      <OurProducts />
      <Partners />
      <OurService services={services.slice(0, 4)} loading={loading} />
      <WhyChooseUs />
      <FAQ />
      <LatestServiceOffer />
    </div>
  );
};

export default Home;
